import * as Diagram from "../../../../components/diagram";

export const EstablishCaseList = {
  label: "立案名單",
  key: "EstablishCaseList",
  path: "BoneMuscleCare/EstablishCaseList",
  api: "TCS_V_CaseFilingList",
  render: (options) => (
    <Diagram.BoneMuscleCare.EstablishCaseList {...options} />
  ),
  isRaw: true,
  isPage: true,
  columns: [
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
    {
      key: "個案ID",
      field: "個案ID",
      header: "個案ID",
    },
    {
      key: "個案姓名",
      field: "個案姓名",
      header: "個案姓名",
    },
    {
      key: "檢查年齡",
      field: "檢查年齡",
      header: "檢查年齡",
    },
    {
      key: "電話",
      field: "電話",
      header: "電話",
    },
    {
      key: "手機",
      field: "手機",
      header: "手機",
    },
    {
      key: "髖骨T值(右)",
      field: "髖骨T值(右)",
      header: "髖骨T值(右)",
    },
    {
      key: "髖骨T值(左)",
      field: "髖骨T值(左)",
      header: "髖骨T值(左)",
    },
    {
      key: "腰椎T值",
      field: "腰椎T值",
      header: "腰椎T值",
    },
    {
      key: "髖骨骨折風險",
      field: "髖骨骨折風險",
      header: "髖骨骨折風險",
    },
    {
      key: "主要骨鬆性骨折風險",
      field: "主要骨鬆性骨折風險",
      header: "主要骨鬆性骨折風險",
    },
    {
      key: "DXA的BMD T值",
      field: "DXA的BMD T值",
      header: "DXA的BMD T值",
    },
    {
      key: "曾發生低能量骨折",
      field: "曾發生低能量骨折",
      header: "曾發生低能量骨折",
    },
    {
      key: "STEADI跌倒量表",
      field: "STEADI跌倒量表",
      header: "STEADI跌倒量表",
    },
    {
      key: "肌少症篩檢",
      field: "肌少症篩檢",
      header: "肌少症篩檢",
    },
    {
      key: "地址",
      field: "地址",
      header: "地址",
    },
    {
      key: "立案日期",
      field: "立案日期",
      header: "立案日期",
    },
    {
      key: "篩檢日期",
      field: "篩檢日期",
      header: "篩檢日期",
    },
  ],
};
